const EmojiCategory = Object.freeze({
  EMOJI: 'EMOJI',
  EMOTION: 'EMOTION',
  TYPE: 'TYPE',
  ALL: 'ALL'
})
export default EmojiCategory
// RESERVE BELOW
